/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var prefix = "t";
var config = {
  prefix: prefix
};

exports["default"] = config;
exports.prefix = prefix;
//# sourceMappingURL=config.js.map
